// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2IjOK","header":"ReportDetails_header__pYmHo","title":"ReportDetails_title__2mw-N","left":"ReportDetails_left__QTWS1"};